export enum ServiceParking {
  PAID_PARKING = 'PAID_PARKING',
  FREE_PARKING = 'FREE_PARKING',
  NO_PARKING = 'NO_PARKING',
}
